import React from "react";
import { Sparkle } from "lucide-react";

export default function FeaturedIn() {
  return (
    <section
      id="featured-in"
      data-testid="featured-in-section"
      className="relative bg-[#050505] py-14 md:py-20 lg:py-28 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-10 h-px bg-[#7FB3D5]/40" />
            <Sparkle
              className="w-3 h-3 text-[#7FB3D5]"
              fill="#7FB3D5"
              strokeWidth={0.6}
            />
            <span
              data-testid="featured-in-eyebrow"
              className="text-[10px] uppercase tracking-[0.4em] text-[#7FB3D5]"
            >
              As featured &amp; placed in
            </span>
            <Sparkle
              className="w-3 h-3 text-[#7FB3D5]"
              fill="#7FB3D5"
              strokeWidth={0.6}
            />
            <span className="w-10 h-px bg-[#7FB3D5]/40" />
          </div>

          <h2
            data-testid="featured-in-headline"
            className="font-display text-2xl md:text-4xl lg:text-5xl text-white font-light leading-snug tracking-tight max-w-3xl"
          >
            Trusted by the press,
            <span className="italic text-[#7FB3D5]"> read by the world</span>.
          </h2>

          <p className="mt-5 text-sm md:text-base text-white/55 max-w-2xl leading-relaxed">
            Strategic visibility across the publications that shape
            conversations in business, culture, finance and innovation.
          </p>
        </div>

        <div
          data-testid="featured-in-logos"
          className="mt-12 md:mt-16 relative"
        >
          <div className="absolute -top-2 -left-2 w-full h-full border border-[#7FB3D5]/20 pointer-events-none" />
          <div className="relative bg-[#080808] border border-white/10 p-6 md:p-10 overflow-hidden">
            <img
              src="/assets/featured-in.jpg"
              alt="Featured in Forbes, Wall Street Journal, TechCrunch, Inc., Entrepreneur, Bloomberg, CNBC, Business Insider, Yahoo Finance, Washington Post, Financial Times and Reuters"
              data-testid="featured-in-image"
              className="w-full h-auto object-contain mix-blend-screen opacity-90 hover:opacity-100 transition-opacity duration-500"
              loading="lazy"
            />
          </div>
        </div>

        <p
          data-testid="featured-in-disclaimer"
          className="mt-8 text-center text-[10px] uppercase tracking-[0.3em] text-white/35"
        >
          ✦ Editorial coverage &amp; placement opportunities ✦
        </p>
      </div>
    </section>
  );
}
